import { Component } from "react"
import PropTypes from "prop-types"
import { Button } from "@mui/material"
import ExperimentsList from "../experiments-list"
import CompareSearch from "../compare-search"

export default class AddOptions extends Component {
  static propTypes = {
    openDialog: PropTypes.func.isRequired,
    trackExperimentTypeSelection: PropTypes.func.isRequired,
    trackAddExperiment: PropTypes.func.isRequired,
    account: PropTypes.string.isRequired,
    modelId: PropTypes.string.isRequired,
    researchTopicId: PropTypes.string.isRequired,
    searchItemsActions: PropTypes.object.isRequired,
    disableSearchResult: PropTypes.func.isRequired,
    toggleSaveExperiment: PropTypes.func.isRequired,
    openCreateInstrumentHedge: PropTypes.func.isRequired,
    isInstrumentPortfolio: PropTypes.bool.isRequired,
  }

  openSearch = () => {
    const { account, openDialog, modelId, searchItemsActions, disableSearchResult, researchTopicId } = this.props
    openDialog({
      title: "Search For Comparison",
      content: <CompareSearch account={account} modelId={modelId} itemsActions={searchItemsActions} researchTopicId={researchTopicId} disableSearchResult={disableSearchResult} />,
    })
  }

  openExperimentsList = () => {
    const { openDialog, trackExperimentTypeSelection, toggleSaveExperiment, trackAddExperiment, account, researchTopicId, openCreateInstrumentHedge, isInstrumentPortfolio } = this.props
    trackAddExperiment()
    openDialog({
      title: "Add experiment",
      content: <ExperimentsList
        researchTopicId={researchTopicId}
        account={account}
        trackExperimentTypeSelection={trackExperimentTypeSelection}
        openSearch={this.openSearch}
        toggleSaveExperiment={toggleSaveExperiment}
        openCreateInstrumentHedge={openCreateInstrumentHedge}
        isInstrumentPortfolio={isInstrumentPortfolio}
      />,
    })
  }

  render() {
    return <Button color="primary" onClick={this.openExperimentsList} variant="text">
      + Add Experiment
    </Button>
  }
}
